import nonSmokerIcon from "apps/QuoterApp/assets/images/No smoking Icon.svg";
import smokerIcon from "apps/QuoterApp/assets/images/Smoking Icon.svg";
import nonSmokerIconSelected from "apps/QuoterApp/assets/images/No smoking Icon - Selected.svg";
import smokerIconSelected from "apps/QuoterApp/assets/images/Smoking Icon - Selected.svg";


export const NON_SMOKER = "1";
export const SMOKER = "3";

export const SMOKING_CHOICES = {
    [NON_SMOKER]: "No",
    [SMOKER]: "Yes",
};

export const SMOKING_ICONS = {
    [NON_SMOKER]: nonSmokerIcon,
    [SMOKER]: smokerIcon,
};

export const SMOKING_ICONS_SELECTED = {
    [NON_SMOKER]: nonSmokerIconSelected,
    [SMOKER]: smokerIconSelected,
};

export const SMOKING_VALUES = Object.keys(SMOKING_CHOICES);
